/**
 * ARTIST DASHBOARD ROUTES
 * * ROUTE FILE NAME NEED SAME WITH REAL PATH! EXCEPT HOME
 */
import { isExContributor } from '@motionelements/core/src/services/account.service.js';
import artistRoutes from './artist-routes.js';
import artistMetadataImportRoutes from './artist-metadata-import.js';
import routeConst from './const.js';

const allArtistChildrenRoutes = artistRoutes.concat(artistMetadataImportRoutes);

const exContributorAllowedRoutes = ['artist-payout', 'artist-sales-list-on-demand'];
const exContributorGuard = (to, next) => {
  if (isExContributor() && !exContributorAllowedRoutes.includes(to.name)) {
    console.log('%c exContributor, redirect to Payouts', 'color: red');
    next(`/${routeConst.CONTRIBUTOR}/payout`);
  }
  next();
};

export default [
  {
    path: `/:lang?/${routeConst.CONTRIBUTOR}`,
    component: () => import(
      /* webpackChunkName: "artist-console" */
      '@/views/artist/ArtistConsole.vue'
    ),
    beforeEnter: (to, from, next) => {
      exContributorGuard(to, next);
    },
    children: allArtistChildrenRoutes,
  },
  {
    path: `/:lang?/${routeConst.CONTRIBUTOR}/elements/edit/:elementId`,
    alias: `/:lang?/${routeConst.CONTRIBUTOR}/elements/editor/:elementId`, // temp for transition
    name: routeConst.ARTIST_ELEMENT_EDIT,
    component: () => import(
      /* webpackChunkName: "artist-elements-edit" */
      '@/views/artist/element/edit/Edit.vue'
    ),
    beforeEnter: (to, from, next) => {
      exContributorGuard(to, next);
    },
  },
  {
    path: `/:lang?/${routeConst.CONTRIBUTOR}/collections/edit/:collectionId`,
    alias: `/:lang?/${routeConst.CONTRIBUTOR}/collection/edit/:collectionId`, // temp for transition
    name: routeConst.ARTIST_COLLECTION_EDIT,
    component: () => import(
      /* webpackChunkName: "artist-collections-edit-page" */
      '@/views/artist/collection/edit/EditPage.vue'
    ),
    beforeEnter: (to, from, next) => {
      exContributorGuard(to, next);
    },
  },
  {
    path: `/:lang?/${routeConst.CONTRIBUTOR}/page/edit`,
    name: routeConst.ARTIST_PROFILE_EDIT,
    component: () => import(
      /* webpackChunkName: "artist-page-edit-page" */
      '@/views/artist/page/EditProfilePage.vue'
    ),
    beforeEnter: (to, from, next) => {
      exContributorGuard(to, next);
    },
  },
];
